import * as React from "react";
import { BaseComponent } from "../../../react-core/Html/BaseComponent";
import { UserClaim } from "../../../Wrap/Constants/Enums/UserClaim";
import { portfolioDashboardTabEnum } from "../../Dashboard/Components/Clients/PortfolioDashboard/Resource/Content";
import { DashboardTab } from "../../Dashboard/Components/Dashboard/Resource/Content";
import CoachMarker from "../CoachMarkers/CoachMarker";
import { checkPermission } from "../Permission/PermissionHelper";
import { CommonHelper } from "../../../react-core/Helpers/CommonHelper";
import { isConsolidate, selectedHeadAccountsOnly } from "../../Dashboard/Components/Clients/PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { ClientAccount } from "../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { PortfolioDashboardMultiSelectionStore, PortfolioDashboardStore } from "../../Dashboard/Components/Clients/PortfolioDashboard/Store/Variable";
import { Permission } from "../Permission/Permission";
import { ContextStore } from "../../../react-core/Flux/Variables";
import { ContextType } from "../../../Wrap/Constants/Enums/ContextType";

interface ITabProps {
    tabs: any;
    existUnReadNotifications?: boolean;
    curTabIndex: any;
    onClick: (tab) => void;
    permission?: Map<any, UserClaim | UserClaim[]>;
    cssWrapper?: string;
}

interface ITabState {
    curTab: any;
    tabs: JSX.Element[];
    allAccounts: ClientAccount[];
    selectedAccounts: string[];
}

export class Tab extends BaseComponent<ITabProps, ITabState> {
    private newWindow;

    constructor(props: ITabProps) {
        super(props);
        this.state = {
            curTab: props.curTabIndex,
            tabs: [],
            allAccounts: PortfolioDashboardStore.getData(),
            selectedAccounts: PortfolioDashboardMultiSelectionStore.getData(),
        };
        this.subscribeToStore(PortfolioDashboardStore, () => this.onDashboardStoreChange());
        this.subscribeToStore(PortfolioDashboardMultiSelectionStore, () => this.onStoreChange());
    }

    private onDashboardStoreChange() {
        this.setState({ allAccounts: PortfolioDashboardStore.getData() });
    }

    private onStoreChange() {
        this.setState({ selectedAccounts: PortfolioDashboardMultiSelectionStore.getData() });
    }

    componentWillReceiveProps(nextProps: ITabProps) {
        if (nextProps.curTabIndex != this.state.curTab && nextProps.curTabIndex != null) {
            this.setState({ curTab: nextProps.curTabIndex });
        }
    }

    componentDidUpdate(prevProps: ITabProps) {
        if (JSON.stringify(prevProps.tabs) != JSON.stringify(this.props.tabs)) {
            this.setUpTabs();
        }
    }

    private checkPermission(userClaim: UserClaim | UserClaim[]): boolean {
        return checkPermission(userClaim);
    }

    componentDidMount() {
        this.setUpTabs();
    }

    setUpTabs() {
        let { tabs, permission } = this.props;
        const tab = [];
        if (!permission) {permission = new Map();}
        let index = this.state.curTab || null;
        for (const key in tabs) {
            if (permission.get(tabs[key])) {
                if (this.checkPermission(permission.get(tabs[key]))) {
                    if (index == null) {index = tabs[key];}
                    tab.push(tabs[key]);
                }
            } else {
                if (index == null) {index = tabs[key];}
                tab.push(tabs[key]);
            }
        }
        if ((Array.isArray(tabs) && !tabs.includes(index)) || (!Array.isArray(tabs) && !tabs[index])) {index = tab[0];}
        if (index != this.state.curTab) {this.props.onClick(index);}
        this.setState({ tabs: tab, curTab: index });
    }
    
    getSelectedHierarchyIdString(selectedAccounts: ClientAccount[]) {
        return selectedAccounts.map((selectedAccount) => selectedAccount.HierarchyId);
    }

    render() {
        if (this.state.tabs.length == 0) {return null;}
        const tab = [];
        const selectedHeadAccounts = selectedHeadAccountsOnly(this.state.selectedAccounts, this.state.allAccounts);
        for (const key in this.state.tabs) {
            tab.push(
                <React.Fragment key={key}>
                    {this.state.curTab === portfolioDashboardTabEnum.Roles && this.state.curTab === this.state.tabs[key] && (
                        <CoachMarker coachMarkerKey="client-roles" />
                    )}
                    <button
                            role="tab"
                            key={`tab-${key}`}
                            id={`tab-${key}`}
                            className="item"
                            aria-selected={this.state.curTab === this.state.tabs[key]}
                            aria-controls={`panel-${key}`}
                            onClick={() => {
                                this.setState({ curTab: this.state.tabs[key] });
                                this.props.onClick(this.state.tabs[key]);
                            }}
                        >
                            {this.state.tabs[key]}
                            {this.props.tabs[key] === DashboardTab.Notification && (
                                <span className={this.props?.existUnReadNotifications ? "icon unread" : "icon read"} aria-hidden={true}></span>
                            )}                        
                        </button>
                </React.Fragment>
            );
        }

        return <nav aria-labelledby="nav2" className={`tabs ${this.props.cssWrapper}`}><h2 id="nav2" className="sr-only">Tabs navigation</h2><div role="tablist">{tab}</div></nav>;
    }
}
